import { render } from "./index.vue?vue&type=template&id=be6629bc"
const script = {}
script.render = render

export default script